import { doc, getDoc, setDoc, deleteDoc, serverTimestamp } from 'firebase/firestore'
import { db } from '@/firebase'
import { RULE_EXPECTATIONS, attempt, accessDetail, fmtExpected } from '../ruleExpectations.js'

// Probe emailConfig/smoke_probe — never emailConfig/global. Read is any-admin;
// write is district-tier only (admin / district_admin).

export default {
  id: 'emailConfig',
  label: 'Email config read/write',
  description:
    'emailConfig/smoke_probe read is admin-tier; write is district-tier only. Does not touch emailConfig/global.',
  destructive: true,

  async run(ctx, step) {
    const role = ctx.roleClaim
    const ref = doc(db, 'emailConfig', 'smoke_probe')
    const expectRead = RULE_EXPECTATIONS.emailConfigRead(role)
    const expectWrite = RULE_EXPECTATIONS.emailConfigWrite(role)

    try {
      await step(`write email config probe (expected: ${fmtExpected(expectWrite)})`, async () => {
        const { allowed } = await attempt(() =>
          setDoc(ref, {
            provider: 'none',
            note: 'SMOKE probe — safe to delete',
            __smokeTest: true,
            __smokeRunId: ctx.runId,
            createdAt: serverTimestamp()
          })
        )
        return allowed
          ? `${accessDetail(expectWrite, allowed)} — emailConfig/smoke_probe`
          : accessDetail(expectWrite, allowed)
      })

      await step(`read email config probe (expected: ${fmtExpected(expectRead)})`, async () => {
        const { allowed } = await attempt(() => getDoc(ref))
        return accessDetail(expectRead, allowed)
      })

      if (expectWrite) {
        await step('delete email config probe (expected: allowed)', async () => {
          const { allowed } = await attempt(() => deleteDoc(ref))
          return accessDetail(true, allowed)
        })
      } else {
        step.skip('delete email config probe', 'Write denied — nothing to delete')
      }
    } finally {
      await deleteDoc(ref).catch(() => {})
    }
  }
}
